import styled from "styled-components";
import { Checkbox } from "antd";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 480px;
  max-width: 90vw;
  padding: 24px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid #f4f4f5;
`;

export const Title = styled.h2`
  margin: 0;
  color: #0a5f7c;
  font-family: "Open Sans", sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;
`;

export const CloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.45);

  &:hover {
    color: rgba(0, 0, 0, 0.65);
  }
`;

export const Description = styled.p`
  margin: 0;
  color: rgba(0, 0, 0, 0.65);
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
`;

export const StyledCheckbox = styled(Checkbox)`
  margin-top: 20px;

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #11a7d9;
    border-color: #11a7d9;
  }

  .ant-checkbox:hover .ant-checkbox-inner {
    border-color: #11a7d9;
  }

  span {
    color: rgba(0, 0, 0, 0.88);
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    font-weight: 400;
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
`;

export const CancelButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 16px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.88);
  font-family: "Open Sans", sans-serif;
  font-size: 14px;

  &:hover {
    border-color: #11a7d9;
  }
`;

export const ConfirmButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 16px;
  border: 1px solid #11a7d9;
  border-radius: 6px;
  background: #11a7d9;
  cursor: pointer;
  color: #fff;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;

  &:hover {
    background: #0f97c4;
    border-color: #0f97c4;
  }

  &:disabled {
    border-color: #e4e4e7;
    background: #f5f5f5;
    color: rgba(0, 0, 0, 0.25);
    cursor: not-allowed;
  }
`;
